import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import competentProfessionalProjectTemplateService from '../../services/competent_professional_project_template.service';
import CompetentProfessionalList from './CompetentProfessionalList';
import CompetentProfessionalSelectModal from './CompetentProfessionalSelectModal';
import CompetentProfessionalImportModal from '../../company/CompetentProfessional/CompetentProfessionalImportModal';
import StaffCostTemplateImportStatus from '@rd-web-markets/shared/dist/claim_group/StaffCostTemplateImportStatus';
const acceptedStatusForDisable = 'pending';
const acceptedStatusToShowData = ['imported_successfully', 'imported_unsuccessfully', 'never_imported', undefined];
export default function CompetentProfessionalDetails(_ref) {
  let {
    companyId,
    forNewProjectCreation = false,
    claimGroup = null,
    addCompetentProfessionalToNewProject = () => {},
    newProjectCompetentProfessionals = [],
    updateNewProjectCompetentProfessionals = () => {},
    removeNewProjectCompetentProfessional = () => {}
  } = _ref;
  const tableHeadings = ['name', 'qualifications', 'relevant_experience', 'email', 'phone', forNewProjectCreation ? null : 'exclude_from_rnd_report', forNewProjectCreation ? null : 'review_narrative', 'notes', '' // for: delete button
  ].filter(h => h !== null);
  const [data, setData, importStatus, importTemplate, report_id, searchQuery] = competentProfessionalProjectTemplateService.useImportStatus(companyId, forNewProjectCreation);
  const [emptyCompetentProfessional, setEmptyCompetentProfessional] = useState([]);
  const [showCompetentProfessionalSelectModal, setShowCompetentProfessionalSelectModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const {
    t
  } = useTranslation();
  const exportTemplate = competentProfessionalProjectTemplateService.useExportTemplate;
  const disableImportExport = acceptedStatusForDisable === importStatus.import_status;
  const showCurrentTableData = acceptedStatusToShowData.includes(importStatus.import_status);
  const removeEmptyRow = rowIdToRemove => {
    if (forNewProjectCreation) {
      removeNewProjectCompetentProfessional({
        id: rowIdToRemove
      });
    } else {
      const newList = emptyCompetentProfessional.filter(emptyCompetentProfessional => emptyCompetentProfessional.emptyRowId !== rowIdToRemove);
      setEmptyCompetentProfessional([...newList]);
    }
  };
  const addContact = () => {
    const newEmptyRowData = {
      emptyRowId: 0,
      claim_project_report_id: report_id,
      name: null,
      email: null,
      qualifications: null,
      relevant_experience: null,
      phone: null,
      competent_professional_claim_project_reports: [{
        claim_project_report_id: report_id,
        exclude_from_rnd_report: true,
        review_narrative: false,
        notes: null
      }]
    };
    if (forNewProjectCreation) {
      addCompetentProfessionalToNewProject(newEmptyRowData);
    } else if (emptyCompetentProfessional.length) {
      const largestId = Math.max(...emptyCompetentProfessional.map(e => e.emptyRowId));
      setEmptyCompetentProfessional([...emptyCompetentProfessional, {
        ...newEmptyRowData,
        emptyRowId: largestId + 1
      }]);
    } else {
      setEmptyCompetentProfessional([newEmptyRowData]);
    }
  };

  // console.log('From CompetentProfessionalDetails: ', newProjectCompetentProfessionals)

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompetentProfessionalSelectModal, {
    claimGroup: claimGroup,
    show: showCompetentProfessionalSelectModal,
    onHide: () => setShowCompetentProfessionalSelectModal(false),
    setTableData: setData,
    tableData: data,
    forNewProjectCreation: forNewProjectCreation,
    addCompetentProfessionalToNewProject: addCompetentProfessionalToNewProject,
    newProjectCompetentProfessionals: newProjectCompetentProfessionals
  }), /*#__PURE__*/React.createElement(CompetentProfessionalImportModal, {
    show: showImportModal,
    onHide: () => setShowImportModal(false),
    importTemplate: importTemplate
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-4 mb-1"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "add",
    loading: false,
    disabled: !!searchQuery.length,
    onClick: () => {
      addContact();
    }
  }, t('add_contact'))), (report_id || forNewProjectCreation) && /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "add",
    loading: false,
    disabled: !!searchQuery.length,
    onClick: () => {
      setShowCompetentProfessionalSelectModal(true);
    }
  }, t('select_existing_name_from_list'))), !forNewProjectCreation && /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Button, {
    className: "me-2 mb-2",
    icon: "cloud_upload",
    disabled: disableImportExport,
    loading: false,
    onClick: () => setShowImportModal(true)
  }, t('import_competent_professional_non_confidential')), /*#__PURE__*/React.createElement(Button, {
    icon: "cloud_download",
    disabled: disableImportExport,
    loading: false,
    onClick: () => exportTemplate(report_id, companyId),
    className: "me-1 mb-2"
  }, t('export_competent_professional_non_confidential')))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(StaffCostTemplateImportStatus, {
    importStatus: importStatus
  }))), showCurrentTableData && /*#__PURE__*/React.createElement(CompetentProfessionalList, {
    companyId: companyId,
    setData: forNewProjectCreation ? updateNewProjectCompetentProfessionals : setData,
    data: forNewProjectCreation ? newProjectCompetentProfessionals : data,
    selectedProjectId: report_id,
    emptyList: emptyCompetentProfessional,
    removeEmptyRow: removeEmptyRow,
    tableHeadings: tableHeadings,
    showFileColumns: false,
    searchQuery: searchQuery,
    forNewProjectCreation: forNewProjectCreation,
    addCompetentProfessionalToNewProject: addCompetentProfessionalToNewProject,
    updateNewProjectCompetentProfessionals: updateNewProjectCompetentProfessionals,
    removeNewProjectCompetentProfessional: removeNewProjectCompetentProfessional,
    claimGroup: claimGroup
  }));
}